<template>
<div :class="['modal', {'is-active': true}]" v-if="cart">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="cart-confirmation bg-white">
            <header class="columns is-marginless">
                <div class="column">
                    <h2 class="title has-text-success is-marginless is-5"><i class="fas fa-check"></i> Product successfully added to your shopping cart</h2>
                </div>
                <div class="column is-narrow">
                    <button @click.prevent="close" class="delete is-large" aria-label="close"></button>
                </div>
            </header>
            <div class="content">
                <div class="columns is-marginless is-variable is-8">
                    <div class="column col-product">
                        <div class="columns is-variable is-3">
                            <div class="column col-product__left">
                                <figure>
                                    <img :src="product.thumb.url" :alt="product.title" />
                                </figure>
                            </div>
                            <div class="column col-product__right">
                                <p class="title">{{product.title}}</p>
                                <p class="subtitle" v-if="!product.special_price">
                                    <span class="price" itemprop="price">{{product.price.toDollar()}}</span>
                                </p>
                                <p class="subtitle" v-else>
                                    <span class="price" itemprop="price">{{product.special_price.toDollar()}}</span>
                                    <strike class="price-was">{{product.price.toDollar()}}</strike>
                                </p>
                                <p><strong>Quantity</strong>: {{already_in_cart}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="column col-order">
                        <div class="columns">
                            <div class="column">
                                <p class="title">There {{cart.count > 1 ? 'are' : 'is'}} {{cart.count}} item{{cart.count > 1 ? 's' : ''}} in your cart.</p>
                                <p><strong>Total amount</strong>: {{cart.amount.toDollar()}}</p>
                                <p><strong>Total shipping</strong>: {{cart.shipping_cost ? cart.shipping_cost.toDollar() : 'to be quoted.'}}</p>
                                <p><strong>GST</strong>: {{cart.gst.toDollar()}}</p>
                                <p><strong>Grand total</strong>: {{cart.grand_total.toDollar()}}</p>
                                <div class="actions">
                                    <button @click.prevent="close" class="button">Continue Shopping</button>
                                    <router-link class="button is-primary" to="/cart"><i class="fas fa-check"></i> Proceed to Checkout</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name    :   'CartConfirmModal',
    data()
    {
        return {
            cart    :   null
        }
    },
    created()
    {
        this.$bus.$on('onCartConfirm', (cart) => {
            this.cart   =   cart;
        });
    },
    computed    :   {
        product()
        {
            if (this.cart) {
                return this.cart.newly_added;
            }

            return null;
        },
        already_in_cart()
        {
            if (this.cart) {
                let found   =   this.cart.items.find(o => o.product_id == this.product.id);
                return found ? found.quantity : null;
            }

            return null;
        }
    },
    watch   :   {
        cart(nv, ov)
        {
            if (nv) {
                $('html').addClass('is-locked');
            } else {
                $('html').removeClass('is-locked');
            }
        }
    },
    methods :   {
        close()
        {
            this.cart   =   null;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/CartConfirmModal.vue